import { service } from '../../../../helpers/http' 

export const ActionGetHourGroups = ({ dispatch }, payload) => { 
    return service({
        module: 'domainHourGroup',
        action: 'getHourGroups',
        payload: payload
    })
}

export const ActionPostHourGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainHourGroup',
        action: 'postHourGroups',
        payload: payload
    })
    
}

export const ActionPutHourGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainHourGroup',
        action: 'putHourGroups',
        payload: payload
    })
    
}

export const ActionDeleteHourGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainHourGroup',
        action: 'deleteHourGroups',
        payload: payload
    })

}

export const ActionGetHourGroupsCatalogHealthSummary = ({ dispatch }, payload) => {

    return service({
        module: 'domainHourGroup',
        action: 'catalogHealthSummary',
        payload: payload
    })

}

export const ActionGetHourGroupCatalogHealth = ({ dispatch }, payload) => {

    return service({
        module: 'domainHourGroup',
        action: 'catalogHealth',
        payload: payload
    })

}
